import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { createEntitySlice, EntityState } from 'app/shared/reducers/reducer.utils';
import { defaultValue, IKpiConfWeight } from 'app/shared/model/kpi-conf-weight.model';

const initialState: EntityState<IKpiConfWeight> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/kpi-conf-weight';

// Actions

export const getEntitiesByPresetWeight = createAsyncThunk(
  'kpiConfWeight/fetch_entity_list_by_preset',
  async (params: { presetId?: number | null; companyId?: number | null }) => {
    const { presetId, companyId } = params;
    const presetParam = presetId !== undefined && presetId !== null ? presetId : 'null';

    let requestUrl = `${apiUrl}/preset/${presetParam}`;

    if (companyId !== null && companyId !== undefined) {
      requestUrl += `?companyId=${companyId}`;
    }

    return axios.get<IKpiConfWeight[]>(requestUrl);
  }
);

// slice

export const KpiConfWeightSlice = createEntitySlice({
  name: 'kpiConfWeight',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEntitiesByPresetWeight), (state, action) => {
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
        };
      })
      .addMatcher(isPending(getEntitiesByPresetWeight), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      });
  },
});

export const { reset } = KpiConfWeightSlice.actions;

// Reducer
export default KpiConfWeightSlice.reducer;
